export default __webpack_public_path__ + "677eabd1d68fb549789a4a180b436d8d.woff2";